module.exports = __webpack_public_path__ + "img/todos.52099591.svg";